"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../../types");
var overrides_1 = require("../../shared/overrides");
var typography_1 = require("../../shared/typography");
var resolveBrandTypographyConfig_1 = require("../../utils/resolveBrandTypographyConfig");
var chips_1 = require("../../shared/chips");
var palette_1 = require("./palette");
var typography_2 = require("./typography");
var buttons_1 = require("./buttons");
var chips_2 = require("./chips");
var badges_1 = require("./badges");
var alerts_1 = require("./alerts");
var overrides_2 = require("./overrides");
var themeObj = {
    palette: palette_1.wellNowPalette,
    typography: (0, resolveBrandTypographyConfig_1.resolveBrandTypographyConfig)(types_1.TAGBrand.WellNow),
    components: __assign(__assign({ MuiTypography: {
            defaultProps: { variantMapping: typography_1.typographyVariantMapping },
            variants: typography_2.wellNowTypography,
        }, MuiButtonBase: {
            defaultProps: { disableTouchRipple: true },
        }, MuiButton: buttons_1.wellNowButtons, MuiFab: { variants: buttons_1.wellNowFloatingButtons }, MuiChip: {
            variants: __spreadArray(__spreadArray([], chips_2.chipVariants, true), badges_1.chipBadgeVariants, true),
            styleOverrides: __assign({}, chips_1.chipStyleOverride),
        }, MuiAlert: alerts_1.wellNowAlerts }, (0, overrides_1.sharedOverrides)(types_1.TAGBrand.WellNow)), overrides_2.overrides),
};
exports.default = themeObj;
